import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import VueResource from 'vue-resource'
import 'view-design/dist/styles/iview.css'


router.beforeEach((to, from, next) => {
    if(to.path === '/'){
        next({
            path: '/single/Home',
            /* query: {
                 redirect: to.fullPath
             } // 将跳转的路由path作为参数，登录成功后跳转到该路由*/
        })
    }
    if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
        if (store.getters.getUser === null) { // userName
            next({
                path: '/login',
               /* query: {
                    redirect: to.fullPath
                } // 将跳转的路由path作为参数，登录成功后跳转到该路由*/
            })
        }else{
            next();
        }
    } else {
        next();
    }
});


Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(ViewUI)

 new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')




